import type { Item, SearchFilter } from "../types";

export const FIELD_LABELS = [
  { key: "name", label: "Name", path: (it: Item) => it.filename ?? "" },
  { key: "artist", label: "Artist", path: (it: Item) => it.meta?.artist ?? "" },
  { key: "title", label: "Title", path: (it: Item) => it.meta?.title ?? "" },
  { key: "location", label: "Location", path: (it: Item) => it.location ?? "" },
  { key: "deviceid", label: "DeviceId", path: (it: Item) => it.deviceId ?? "" },
  { key: "status", label: "Status", path: (it: Item) => String(it.status ?? "") },
];

export const filterItems = (items: Item[], filter: SearchFilter): Item[] => {
  const q = filter.query.trim().toLowerCase();
  if (!q) return items;
  // token syntax support: "name: foo"
  const token = q.match(/^(\w+):\s*(.+)$/);
  let field = filter.field;
  let term = q;
  if (token) {
    field = token[1].toLowerCase();
    term = token[2].toLowerCase();
  }
  const contains = (s: string) => s.toLowerCase().includes(term);
  if (field && FIELD_LABELS.some((f) => f.key === field)) {
    const getter = FIELD_LABELS.find((f) => f.key === field)!.path;
    return items.filter((it) => contains(getter(it)));
  }
  // free-form
  return items.filter((it) =>
    contains([
      it.filename ?? "",
      String(it.status ?? ""),
      it.location ?? "",
      it.deviceId ?? "",
      it.meta?.artist ?? "",
      it.meta?.title ?? "",
      it.meta?.description ?? "",
      it.meta?.date ?? "",
    ].join(" "))
  );
};

